import React from "react";
import { useState } from "react";
import MobileHeader from "../../components/header/MobileHeader";
import NonLoginHeader from "../../components/header/NonLoginHeader";
import Breadcrumb from "../../components/breadcrumb";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import SignIn from "../../components/signin";
import useLocalStorage from "use-local-storage";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import logo2 from "../../assets/images/logo2.png";
import Toggle from "../../Toggle";

function Login(props) {
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);
	// const [isDark] = useLocalStorage("isDark", false);
	
	const [isDark, setIsDark] = useLocalStorage("isDark", false);


  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  return (
    <>
      {/* <MobileHeader handleMobile={handleMobile} /> */}
      {/* <NonLoginHeader clname="actPage9" handleMobile={handleMobile} /> */}
      <header id="header" className="header header-default pt-3">
				<div className="container ct2">
					<div className="row">
						<div className="col-md-12">
							<div className="sticky-area-wrap">
								<div className="header-ct-left">
									{isDark ? (
										<div id="logo" className="logo">
											<Link to="/">
												<img
													className="site-logo"
													id="trans-logo"
													src={logo2}
													alt="sitelogo"
												/>
											</Link>
										</div>
									) :
									 (
										<div id="logo" className="logo">
											<Link to="/">
												<img
													className="site-logo"
													id="trans-logo"
													src={logo}
													alt="sitelogo"
												/>
											</Link>
										</div>
									)}
								</div>
								<div className="header-ct-center">
									<div className="nav-wrap"></div>
								</div>
								<div className="header-ct-right">
								
									<div className="register-login-container me-3">	
										<h3>
										New to Us?
											<span className="login-text-color">
												<Link
													to="/Register"
													className="khojLogin register-login mx-1"
												>
													Sign Up Now
												</Link>{" "}
											</span>
											
										</h3>
									</div>
									  <Toggle
										isChecked={isDark}
										handleChange={() => setIsDark(!isDark)}
										className="desktopToggle"
										/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</header>
      <div className="pt-70">
      <SignIn />
      <Gotop />
      </div>
    </>
  );
}

export default Login;
